// removed by extract-text-webpack-plugin
module.exports = {"root":"Loader__root___1RSzy","label":"Loader__label___1fCHX"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/Loader.scss
// module id = 985
// module chunks = 0